import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {AuthenticatedBaseComponent} from '../../../authenticated-base.component';
import {RouterLink} from '@angular/router';
import {TranslatePipe} from '@ngx-translate/core';
import {TableComponent} from '../../../../components/table/table.component';

@Component({
  selector: 'app-authenticated-administration-emails-index',
  templateUrl: './index.component.html',
  imports: [
    RouterLink,
    TranslatePipe,
    TableComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IndexComponent extends AuthenticatedBaseComponent implements OnInit {
  public ngOnInit() {
    this.titleService.setTitle('authenticated.administration.emails.index.title');
  }
}
